import SJButton from '@/components/SJButton'
import { useSetState } from 'ahooks'
import accredit from '@/stores/accredit'
import user from '@/stores/user'
import { Registration, RegistrationPostReq } from '@/services/types/accredit'
import { postRegistration } from '@/services/accredit'
import { observer } from 'mobx-react'
import SJCropper from '@/components/SJCropper'
import { Toast } from 'antd-mobile'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { sleep } from 'antd-mobile/es/utils/sleep'
import { getImage } from '@/utils/utils'
import SJSpace from '@/components/SJSpace'
import './index.less'

interface State {
  applicant_name: string
  identification_type: string
  identification_num: string
  birthday: string
}

const RegistrationStep2 = () => {
  document.title = '评测报名'
  const navigate = useNavigate()
  const params = useLocation() as { state: State }
  const { applicant_name, identification_type, identification_num, birthday } = params.state

  const [state, setState] = useSetState({
    applicant_name: '', // Y 评测申请人姓名
    identification_type: '居民身份证', // Y 评测申请人证件类型
    identification_num: '',
    birthday: '',
    photo: '', // 照片大小限制了
    base64: '',
    loading: false,
    visible: false,
  })

  useEffect(() => {
    setState({
      applicant_name,
      identification_type,
      identification_num,
      birthday,
    })
  }, [applicant_name, identification_type, identification_num, birthday, setState])

  const uploadPhoto = () => {
    setState({ visible: true })
  }
  const handleSubmit = async () => {
    if (state.loading) return
    if (!state.photo) {
      Toast.show('请上传头像')
      return
    }
    const params: RegistrationPostReq = {
      broker_id: String(user.userPlayer.playerId), // Y 代理人id
      applicant_id: accredit.applicant_id, // Y 评测申请人id
      applicant_name: state.applicant_name, // Y 评测申请人姓名
      identification_type: state.identification_type, // Y 评测申请人证件类型
      identification_num: state.identification_num, // Y 评测申请人证件号码
      birthday: state.birthday, // Y 评测申请人证件号码
      applicant_photo: state.photo, // Y 评测申请人证件照
      applying_for_grade: accredit.applicant_grade, // Y 评测申请级别
    }
    try {
      Toast.show({
        icon: 'loading',
        content: '提交申请',
      })
      setState({
        loading: true,
      })
      const res = (await postRegistration(params)) as unknown as Registration
      // const res = params
      console.log(res)
      setState({
        loading: false,
      })
      if (res) {
        accredit.applicant_result = res
        Toast.show({
          icon: 'success',
          content: '报名申请成功',
        })
        await sleep(1500)
        if (user.from === 'CMCC') {
          navigate(`/registration/result?id=${res.id}&from=step2`)
        } else {
          navigate('/registration/order')
        }
      }
    } catch (error) {
      setState({
        loading: false,
      })
      if (error === '存在已报名未评测的记录') {
        accredit.applicant_result = params
        if (user.from === 'CMCC') {
          navigate(-3)
        } else {
          navigate('/registration/order')
        }
      }
    }
  }

  const imageToBase64 = (path: string): any => {
    console.log('path', path)
    setState({ visible: false })
    setState({ photo: path })
    // Taro.getFileSystemManager().readFile({
    //   filePath: path,
    //   encoding: 'base64',
    //   success: (res) => {
    //     console.log(res.data)
    //     // const base64 = 'data:image/jpeg;base64,' + res.data
    //     const base64 = String(res.data)
    //     console.log(base64.length / 1024)
    //     // if (base64.length > 1024 * 1024 * 2) {
    //     //   Toast.show('照片不能超过2M')
    //     //   return ''
    //     // } else {
    //     // }
    //     setState({ base64: base64 })
    //   },
    // })
  }

  return (
    <div className="page registration-step2">
      <div className="main">
        <SJSpace height={40} />
        <div className="title">上传证件照</div>
        <div className="photo" onClick={uploadPhoto}>
          {state.photo ? (
            <img className="avatar" src={getImage(state.photo)} alt="" />
          ) : (
            <div className="avatar">
              <img className="icon-camera" src={require('./camera.png')} alt="" />
              <span className="upload-text">点击上传</span>
              <span className="upload-tip">用于在证书上展示</span>
            </div>
          )}
        </div>
        <div className="section">
          <div className="h3">证件照要求：</div>
          <div className="p">· 一寸或二寸证件照，颜色可以为黑白或彩色</div>
          <div className="p">· 需要看到人的两耳轮廓和相当于男士喉结处的地方</div>
          <div className="p">· 拍照时不得上唇膏等影响真实面貌的化妆色彩</div>
          <div className="p">· 头发不可以染色</div>
        </div>
        <SJSpace height={100} />
      </div>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" disabled={!state.photo} onClick={handleSubmit}>
          提交
        </SJButton>
      </div>
      {state.visible && (
        <SJCropper
          type="stfile"
          checkImageFace
          cropperHeight={640}
          onSuccess={imageToBase64}
          onCancel={() => setState({ visible: false })}
        ></SJCropper>
      )}
    </div>
  )
}

export default observer(RegistrationStep2)
